import { useWindowWidth } from "@react-hook/window-size";
import { useEffect, useState } from "react";

export const useWindowLimit = (
  limit: number,
  options?: { equal?: boolean; lowerThan?: boolean },
) => {
  const windowWidth = useWindowWidth();
  const [result, setResult] = useState<boolean>(false);

  useEffect(() => {
    setResult(() => {
      if (options?.lowerThan) {
        return options.equal ? windowWidth <= limit : windowWidth < limit;
      } else {
        return options?.equal ? windowWidth >= limit : windowWidth > limit;
      }
    });
  }, [window, windowWidth, options, limit]);

  return result;
};
